'use strict';

/**
 * Gets property value of css variable from the root element computed styles. Must be used client side.
 * @param cssVariable css variable (ex. '--space-xy-small-rem')
 * @returns corresponding style property value (ex. '1rem') or empty string
 */
var getValueFromRootElement = function getValueFromRootElement(cssVariable, shouldWarn) {
  if (typeof window === 'undefined') {
    if (shouldWarn) console.warn("Unable to access ".concat(cssVariable, " server side."));
    return '';
  }
  var root = window.document.querySelector(':root');
  var value = getComputedStyle(root).getPropertyValue(cssVariable);
  if (!value) console.error("CSS variable ".concat(cssVariable, " not found."));
  return value;
};

/**
 * This function should really not be used. The reason is that these values must
 * be pulled from CSS files, and therefore are not available serverside.
 * This causes a flash of content where this value cannot be used, causing
 * Flash Of Unstyled Content (FOUC) or Content Layout Shift (CLS) which can
 * negatively impact our google ranking via lighthouse scores.
 *
 *  If you want to use this function,
 * consider putting your value in theme config, or passing it as a defaulted prop
 * to the component.
 *
 * Given a css variable, it returns the corresponding value from the computed style of the root element. Only works client side.
 * @param cssVariable css variable (ex. '--space-xy-small-rem')
 * @returns corresponding style property value (ex. '1rem')
 */
var getTokenValue = function getTokenValue(cssVariable) {
  var shouldWarn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return getValueFromRootElement(cssVariable, shouldWarn);
};

/**
 * Given an array of css variables, it returns the corresponding values from the computed styles of the root element. Only works client side.
 * @param cssVariables array of css variables (ex. ['--space-xy-small-rem', '--space-xy-medium-rem'])
 * @returns array of corresponding style property values (ex. ['1rem', '1.25rem'])
 */
var getTokenValues = function getTokenValues(cssVariables) {
  var shouldWarn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var values = cssVariables.map(function (cssVariable) {
    var value = getTokenValue(cssVariable, shouldWarn);
    return value;
  });
  return values;
};

exports.getTokenValue = getTokenValue;
exports.getTokenValues = getTokenValues;
